import type { UnsubscriptionFlowStages } from '../names';
import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useViewModalPremiumActive = () =>
	useSendEvent(events.subscription.viewModalPremiumActive);

export const useClickButtonShareFeedback = () =>
	useSendEvent(events.subscription.clickButtonShareFeedback);

export const useClickButtonSubmitFeedback = () =>
	useSendEvent(events.subscription.clickButtonSubmitFeedback);

export const useClickButtonCancelRenewalFirst = () =>
	useSendEvent(events.subscription.clickButtonCancelRenewalFirst);

export const useClickButtonKeepBenefitsCancelSub = () =>
	useSendEvent(events.subscription.clickButtonKeepBenefitsCancelSub);

export const useClickButtonImSureCancelSub = () =>
	useSendEvent(events.subscription.clickButtonImSureCancelSub);

export const useClickButtonCancelCancelSub = () =>
	useSendEvent(events.subscription.clickButtonCancelCancelSub);

export const useClickButtonNotNowCancelSub = () =>
	useSendEvent(events.subscription.clickButtonNotNowCancelSub);

export const useViewModalCanceledPremiumCancelSub = () =>
	useSendEvent(events.subscription.viewModalCanceledPremiumCancelSub);

export const useClickButtonReactivateCancelSub = () =>
	useSendEvent(events.subscription.clickButtonReactivateCancelSub);

export const useClickElementCloseCancelSub = (
	stage: UnsubscriptionFlowStages
) =>
	useSendEvent(events.subscription.clickElementCloseCancelSub, {
		modal_stage: stage,
	});

export const useClickLinkContactSupportCancelSub = (
	stage: UnsubscriptionFlowStages
) =>
	useSendEvent(events.subscription.clickLinkContactSupportCancelSub, {
		modal_stage: stage,
	});

export const useClickLinkRefundPolicyCancelSub = (
	stage: UnsubscriptionFlowStages
) =>
	useSendEvent(events.subscription.clickLinkRefundPolicyCancelSub, {
		modal_stage: stage,
	});
